import React from "react";
import { VillaVidFavButtons } from "./VillaVidFavButtons";

export class VillaTileName extends React.Component {
    constructor(props) {
        super(props);
    }
        
    render(){ 
        var data = this.props.data;
        
        return (
            <div className={"flex justify-sbetween items-center " + this.props.className}>
                <h4 className="h2 font-w600 mar-no">
                    <a className="blue1" href={data.villaUri}>{data.name}</a>
                </h4>
                {this.props.vidFavButtonsPosition === 'name' ?
                <VillaVidFavButtons
                    data={data}
                    favouriteVillas={this.props.favouriteVillas}
                    vidButtonClassName="btn-primary"
                    vidButtonIcon="/assets/img/front/icons/video-triangle-reversed.svg"
                    favButtonClassName="btn-tertiary bg-green1-hover"
                    favButtonIcon="/assets/img/front/icons/favourite-heart-blue1.svg"
                    iconHeight="15"
                    favouritedClass="btn-green1"
                    favouritedIcon="/assets/img/front/icons/favourite-heart-reversed.svg"
                />
                :''}
            </div>
        );
    }
}